import { AppList } from "@/components/appList/appList.comp";
import { Banner } from "@/components/banner/banner.comp";
import { Layout } from "@/components/layout/layout.comp";
import { MoreApps } from "@/components/moreApps/moreApps.comp";
import { Platforms } from "@/components/platforms/platforms.comp";
import { SearchHero } from "@/components/searchHero/searchHero.comp";
import { getRandomApps } from "@/lib/search";
import { getSearchEngineDataDB } from "@/lib/searchEngineMongodb";
import { useSearch } from "@/lib/useSearch";
import { IPlatform, THit } from "@/types";
import { useRouter } from "next/router";

export default function ResultsPage({ platforms, categories, moreApps }: { platforms: IPlatform[], categories: string[]; moreApps: THit[]; }) {
    const router = useRouter();
    const q = (router.query.q as string) || '';
    const page = Math.max(1, parseInt(router.query.page as string, 10) || 1);
    const search = useSearch({ q, page, skip: !router.isReady });

    return (
        <Layout
            showFooter={true}
            showHeader={true}
            title={`Results for ${q}`}
        >
            <SearchHero showSearch={false} total={search.total} query={q} />
            <AppList
                categories={categories}
                platforms={platforms}
                hits={search.hits}
                page={search.page}
                totalPages={search.totalPages}
                onPageChange={(p) => {
                    router.push(
                        { pathname: router.pathname, query: { ...router.query, page: p } },
                        undefined,
                        { shallow: true }
                    );
                }}
            />
            <MoreApps appSynonym="app" hits={moreApps} />
            <Platforms />
            <Banner />
        </Layout>
    );
}

export async function getStaticProps() {
    const platforms = await getSearchEngineDataDB<IPlatform>('platforms', {}, {
        displayName: 1,
        name: 1,
        appSynonym: 1
    });
    const categories = await getSearchEngineDataDB<IPlatform>('seocategories', {}, {
        slug: 1,
        displayName: 1,
    });
    const moreApps = await getRandomApps({ limit: 10 });
    return {
        props: { platforms, categories, moreApps },
    };
};
